'use client'

import { useSyncExternalStore } from 'react'

const subscribeToHydration = () => () => {}

export function useHydratedAuthUi(): boolean {
  return useSyncExternalStore(
    subscribeToHydration,
    () => true,
    () => false
  )
}
